import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVault: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVault"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V19H6V21H8V19H16V21H18V19H21V3H3ZM16 11C16 13.2091 14.2091 15 12 15C10.1362 15 8.57006 13.7252 8.12602 12H12V10H8.12602C8.57006 8.27477 10.1362 7 12 7C14.2091 7 16 8.79086 16 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVault;
